import React, { PureComponent } from 'react'
import Constants from 'expo-constants'
import { View, Image, ScrollView } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import Touchable from '../../Atoms/Touchable'
import Icon from '../../Atoms/Icon'
import Button from '../../Atoms/Button'
import HelpIcon from '../../Molecules/Help'

import theme from '../../../styles/theme'
import CEOTransferRequest from './ceotransfer'

import dateFormat from 'dateformat'

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.black};
  justify-content: flex-start;
`

const Header = styled(View)`
  height: 180px;
  width: 100%;
  background-color: ${theme.colours.black};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${theme.gutterUnit}px ${theme.gutterUnit}px ${theme.gutterUnit}px;
`

const Column = styled(View)`
  justify-content: center;
  height: 100%;
`

const GameBranding = styled(Column)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 676px;
`

const GameInfo = styled(Column)`
  width: 496px;
`

const LargerTouchable = styled(Touchable)`
  width: 150px;
  height: 100%;
  justify-content: center;
  padding: 20px 20px 20px 10px;
`

const Body = styled(View)`
  flex: 1;
  padding: ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.lightgrey};
  align-items: center;
  justify-content: center;
`

const LogoColumn = styled(Column)`
  width: 180px;
`

const Logo = styled(Image)`
  width: 150px;
  height: 150px;
`

const MiddleBodyColumn = styled(Column)`
  width: 316px;
  justify-content: space-around;
  align-items: center;
`

const ResourceContainer = styled(View)`
  height: 194px;
  width: 550px;
  background-color: ${theme.colours.white};
  border-radius: 5px;
  padding: ${theme.gutterUnit}px;
`

const ResourceBox = styled(ScrollView)``

const ResourceRow = styled(View)`
  padding-top: ${theme.gutterUnit}px;
  flex-direction: row;
  width: 100%;
`

const ResourceNameColumn = styled(View)`
  width: 70%;
`

const ResourceDateColumn = styled(View)`
  width: 30%;
`

const LogoutContainer = styled(View)`
  width: 150px;
  align-items: flex-end;
  padding-right: 10px;
`

const Footer = styled(View)`
  height: 60px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
`

const getWelcomeMessage = ({ deviceStatusChecked, eventClosed, eventDate, gameStarted, gameState }) => {
  if (eventClosed) {
    return { message: 'This event has now closed', colour: theme.colours.red, enableButton: false }
  }

  if (!deviceStatusChecked) {
    return { message: 'Checking status of the event...', colour: theme.colours.black, enableButton: false }
  }

  if (!gameStarted) {
    return { message: 'This event has not yet commenced', colour: theme.colours.orange, enableButton: false }
  } else if (gameState === 'locked') {
    return { message: 'This event will resume shortly', colour: theme.colours.orange, enableButton: false }
  }
  return { message: 'This event has commenced, use the button below to enter', colour: theme.colours.black, enableButton: true }
}

const CEO_HELP = {
  title: 'What is a CEO?',
  description: 'As CEO, there will be certain decisions which can only be entered into your simulation interface'
}

class WaitingRoom extends PureComponent {
  state = {
    showCEOTransfer: false
  }

  handleShowCEOTransfer = () => {
    this.setState({ showCEOTransfer: true })
  }

  handleHideCEOTransfer = () => {
    this.setState({ showCEOTransfer: false })
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.ceoTransferRequestId && this.props.ceoTransferRequestId) {
      this.setState({ showCEOTransfer: true })
    }
  }

  render () {
    const { team, registered, isMaster, onLogout, onSettingsPress, deviceStatusChecked, gameName, client, logo, eventDate, eventClosed, resources, gameStarted, gameState, onButtonPress, buttonEnabled } = this.props
    const { message, colour, enableButton } = getWelcomeMessage({ deviceStatusChecked, eventClosed, eventDate, gameStarted, gameState })
    const showEnabledButton = buttonEnabled || enableButton
    let teamMessage = ''
    if (team.id) {
      teamMessage += `You are in Team ${team.id}`
    }
    if (team.name) {
      teamMessage += `: ${String(team.name).toUpperCase()} BANK`
    }
    return (
      <Container>
        <Header>
          <LargerTouchable onPress={onSettingsPress}>
            <Icon name='cog' white size='huge' />
          </LargerTouchable>
          <GameBranding>
            <LogoColumn>
              {!!logo && <Logo source={{ uri: logo }} />}
            </LogoColumn>
            <GameInfo>
              <Text white size='huger' bold>{client}</Text>
              <Text white fontSize={32}>{gameName}</Text>
              <Text white size='m' overrides={{ marginTop: theme.gutterUnit / 2 }}>Event will commence on: {dateFormat(eventDate, 'dd mmmm yyyy')}</Text>
            </GameInfo>
          </GameBranding>
          <LogoutContainer>
            <Button
              colour={theme.colours.white}
              borderColour={theme.colours.black}
              rounded
              onPress={onLogout}
              styles={[{ width: 80, marginTop: theme.gutterUnit, padding: 2 * theme.gutterUnit, height: 50 }]}
            >
              <Text size='s' colour={theme.colours.black}>Logout</Text>
            </Button>
          </LogoutContainer>
        </Header>
        <Body>
          <MiddleBodyColumn>
            <View>
              <Text size='l' center>Welcome {this.props.firstName},</Text>
              {!!team.id && <Text center overrides={{ marginTop: theme.gutterUnit / 2 }}>{teamMessage}</Text>}
            </View>
            <Text center colour={colour}>{message}</Text>
            <Button
              colour={showEnabledButton ? theme.colours.blue : theme.colours.grey}
              noborder
              rounded
              onPress={showEnabledButton ? onButtonPress : () => {}}
              disabled={!showEnabledButton}
              styles={[{ width: 316, padding: 2 * theme.gutterUnit, height: 50 }]}
            >
              <Text size='s' colour={showEnabledButton ? theme.colours.white : theme.colours.lightgrey}>Enter Event</Text>
            </Button>
            {registered && isMaster && (
              <View>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <Text center>You are currently the CEO</Text>
                  <HelpIcon colour={theme.colours.bordergrey} size='xl' {...CEO_HELP} />
                </View>
                <Button
                  colour={theme.colours.blue}
                  noborder
                  rounded
                  onPress={this.handleShowCEOTransfer}
                  styles={[{ marginTop: theme.gutterUnit, padding: 2 * theme.gutterUnit, height: 50 }]}
                >
                  <Text size='s' colour={theme.colours.white}>Appoint New CEO</Text>
                </Button>
              </View>
            )}
            {this.state.showCEOTransfer && <CEOTransferRequest onCancel={this.handleHideCEOTransfer} />}
            {resources.length > 0 && (
              <ResourceContainer>
                <ResourceBox>
                  <ResourceRow>
                    <ResourceNameColumn>
                      <Text size='xs' black>Resource Name</Text>
                    </ResourceNameColumn>
                    <ResourceDateColumn>
                      <Text size='xs' black>Date Uploaded</Text>
                    </ResourceDateColumn>
                  </ResourceRow>
                  {resources.map((r, i) => (
                    <ResourceRow key={i}>
                      <ResourceNameColumn>
                        <Text size='xs' link href={r.href} colour={theme.colours.primary}>{r.name}</Text>
                      </ResourceNameColumn>
                      <ResourceDateColumn>
                        <Text bold size='xs'>{dateFormat(r.uploadDate, 'dd.mm.yy')}</Text>
                      </ResourceDateColumn>
                    </ResourceRow>
                  ))}
                </ResourceBox>
              </ResourceContainer>
            )}
          </MiddleBodyColumn>
        </Body>
        <Footer>
          <Text size='l' bold white>Version: {Constants.manifest.version}</Text>
        </Footer>
      </Container>
    )
  }
}

export default WaitingRoom
